import { api } from '../../api/api';
import apiError from '../../api/api-error';

// initial state
const state = {
   rec: null
};

// getters
const getters = {

};

// actions
const actions = {
   COMMUNITY_PLAN_GET:(context, {id})=>{
      return new Promise((resolve, reject)=>{
         api.get('/api/community-plans/'+ id)
         .then((res)=>{
            context.commit('COMMUNITY_PLAN_SET', {rec: res.data});
            resolve();
         })
         .catch((error)=>{
            context.commit('ERROR_MESSAGE_SET',{message:apiError.message('community plan',error)});
            reject(apiError.message('community plan',error));
         });
      });
   },
   COMMUNITY_PLAN_HIGHLIGHT:(context, {})=>{

      const feature = {
         styleLayer: 'community-plans',
         source:'scoutred',
         sourceLayer: 'community_plans',
         id: state.rec.id,
         properties:{
            geohash:state.rec.geohash
         }
      };

      context.commit('MAP_FEATURE_ACTIVE_SET',feature);
   },
   COMMUNITY_PLAN_HIGHLIGHT_CLEAR:(context, {})=>{
      context.commit('MAP_FEATURE_ACTIVE_SET',null);
   },
   COMMUNITY_PLAN_REFERENCE_ADD:async (context, {id, reference})=>{
      const add = {...reference};
      const res = await api.post('/api/community-plans/'+id+'/references', add);
      context.dispatch('COMMUNITY_PLAN_GET',{id});
   },
   COMMUNITY_PLAN_REFERENCE_DELETE:async (context, {id, referenceId})=>{
      const res = await api.delete('/api/community-plans/'+id+'/references/'+referenceId);
      context.dispatch('COMMUNITY_PLAN_GET',{id});
   },
   COMMUNITY_PLAN_REFERENCE_SAVE:async (context, {id, reference, referenceId})=>{
      const res = await api.put('/api/community-plans/'+id+'/references/'+referenceId, reference);
      context.dispatch('COMMUNITY_PLAN_GET',{id});
   },
   COMMUNITY_PLAN_SAVE:async (context, {id, rec})=>{
      const res = await api.put('/api/community-plans/'+ id, rec);
      context.commit('COMMUNITY_PLAN_SET',{rec:rec});
   },
   COMMUNITY_PLAN_ZOOM_TO:(context, {})=>{
      context.commit('MAP_FIT_BOUNDS', {bounds:state.rec.bounds,maxZoom:11});
   },
   
};

// mutations
const mutations = {
   COMMUNITY_PLAN_SET: function(state, {rec}){
      state.rec = rec;
   }
};

export default {
   state,
   getters,
   actions,
   mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/communityPlan.js